// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Loader = require("../../uikit/reason/atoms/Loader/Loader.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var MyBroadcastMessagesWidgetList = require("./MyBroadcastMessagesWidgetList.bs.js");

function MyBroadcastMessagesWidgetRelay(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("h2", {
                            children: "My Broadcast Messages",
                            className: "text-gray-700 text-2xl font-medium"
                          }),
                      className: "flex gap-4 items-center flex-row mb-4"
                    }),
                JsxRuntime.jsx(React.Suspense, {
                      children: Caml_option.some(JsxRuntime.jsx(MyBroadcastMessagesWidgetList.make, {
                                query: props.query,
                                viewMoreMode: props.viewMoreMode
                              })),
                      fallback: Caml_option.some(JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Loader.make, {
                                      loadingText: "Loading messages..."
                                    }),
                                className: "h-[340px] flex items-center justify-center"
                              }))
                    })
              ],
              className: "bg-white p-5 rounded shadow-sm"
            });
}

var make = MyBroadcastMessagesWidgetRelay;

exports.make = make;
/* react Not a pure module */
